/* Holofoil hero — announcement deck carousel.
   Ported from design-concepts/06-holofoil/index.html (~321-440): same
   cycle/foil-sweep/aria behaviour, but slides are rendered server-side as
   section blocks instead of built from a JS data array, and every
   [data-holo-deck] root on the page is wired independently. */
(function () {
  function pad(n) { return ('0' + n).slice(-2); }

  function initDeck(root) {
    if (root.dataset.holoDeckInit === 'true') return;
    root.dataset.holoDeckInit = 'true';

    var viewport = root.querySelector('[data-holo-deck-viewport]');
    if (!viewport) return;
    var sweep = root.querySelector('[data-holo-deck-sweep]');
    var countEl = root.querySelector('[data-holo-deck-count]');
    var prevBtn = root.querySelector('[data-holo-deck-prev]');
    var nextBtn = root.querySelector('[data-holo-deck-next]');

    var slides = Array.prototype.slice.call(viewport.querySelectorAll('.deck-slide'));
    var len = slides.length;
    if (len < 2) return; // nothing to cycle — server-rendered single slide stays put

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var current = 0;
    slides.forEach(function (s, i) { if (s.classList.contains('is-active')) current = i; });
    var timer = null;

    function setCount(idx) {
      if (countEl) countEl.textContent = pad(idx + 1) + ' / ' + pad(len);
    }

    function go(next, dir) {
      next = (next + len) % len;
      if (next === current) return;

      var leaving = slides[current];
      leaving.classList.remove('is-active');
      leaving.classList.add(dir < 0 ? 'is-leaving-back' : 'is-leaving');
      leaving.setAttribute('aria-hidden', 'true');
      setTimeout(function () {
        leaving.classList.remove('is-leaving');
        leaving.classList.remove('is-leaving-back');
      }, 700);

      current = next;
      var entering = slides[current];
      entering.classList.toggle('from-back', dir < 0);
      void entering.offsetWidth; // commit the entry side before activating
      entering.classList.add('is-active');
      entering.setAttribute('aria-hidden', 'false');
      setCount(current);

      // foil-sheen sweep across the card as it changes
      if (sweep) {
        sweep.classList.remove('run');
        void sweep.offsetWidth;
        sweep.classList.add('run');
      }
    }

    // auto-advance ~7s; pause on hover/focus; off for reduced motion
    function play() {
      if (reduced || timer) return;
      timer = setInterval(function () { go(current + 1, 1); }, 7000);
    }
    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }
    function nudge() { stop(); play(); }

    if (prevBtn) prevBtn.addEventListener('click', function () { go(current - 1, -1); nudge(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(current + 1, 1); nudge(); });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', play);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', play);

    /* ---- Touch: swipe to change slides, hold to pause ------------------
       Pointer Events rather than touch* so a mouse drag and a pen work the
       same way. The CSS sets `touch-action: pan-y` on the viewport, so the
       browser keeps owning vertical scroll and only hands us the horizontal
       axis — that's why no preventDefault is needed (and why the listeners
       can stay passive).

       The gesture is axis-locked on first movement: past AXIS_LOCK px the
       drag is committed to whichever axis moved further, so a slightly
       diagonal flick down the page never steals the scroll, and a horizontal
       swipe never gets cancelled by finger wobble.

       The swipe is a DETECTOR, not a drag. An earlier version had the card
       track the finger and then hand off to go() on release, which read as
       two unrelated animations stapled together: the card followed you, let
       go, snapped back, and only then crossfaded out. One transition is
       better than one-and-a-half — the card stays put during the gesture and
       the release plays the same slide-and-fade the arrows and autoplay use,
       so every way of changing slide looks identical. */
    var SWIPE_MIN = 45;   /* px before a release counts as a swipe */
    var AXIS_LOCK = 8;    /* px before the gesture commits to an axis */

    var pointerId = null;
    var startX = 0, startY = 0, dx = 0;
    var axis = null;      /* null = undecided, 'x' = ours, 'y' = the page's */

    function endDrag(commit) {
      if (pointerId === null) return;
      var moved = dx;
      var swiped = commit && axis === 'x' && Math.abs(moved) >= SWIPE_MIN;

      if (viewport.hasPointerCapture && viewport.hasPointerCapture(pointerId)) {
        viewport.releasePointerCapture(pointerId);
      }
      pointerId = null;
      axis = null;
      dx = 0;
      root.classList.remove('is-dragging');

      /* swipe left (negative) reveals the next card */
      if (swiped) go(moved < 0 ? current + 1 : current - 1, moved < 0 ? 1 : -1);
      play();
    }

    viewport.addEventListener('pointerdown', function (e) {
      if (!e.isPrimary || pointerId !== null) return;
      /* Let real controls inside a slide (CTA button, product link) behave
         normally — a drag that starts on them is almost certainly a tap. */
      if (e.target.closest('a, button')) return;
      pointerId = e.pointerId;
      startX = e.clientX;
      startY = e.clientY;
      dx = 0;
      axis = null;
      stop(); /* holding the deck pauses the auto-advance */
    }, { passive: true });

    viewport.addEventListener('pointermove', function (e) {
      if (e.pointerId !== pointerId) return;
      dx = e.clientX - startX;
      var dy = e.clientY - startY;

      if (axis === null) {
        if (Math.abs(dx) < AXIS_LOCK && Math.abs(dy) < AXIS_LOCK) return;
        axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        if (axis === 'y') { endDrag(false); return; }
        root.classList.add('is-dragging');
        /* Capture only once the gesture is ours, so pointerup/cancel always
           land back here even if the finger drifts off the card. Capturing on
           pointerdown instead would swallow taps meant for the page. */
        if (viewport.setPointerCapture) {
          try { viewport.setPointerCapture(pointerId); } catch (err) { /* not capturable */ }
        }
      }
    }, { passive: true });

    viewport.addEventListener('pointerup', function (e) {
      if (e.pointerId === pointerId) endDrag(true);
    }, { passive: true });
    viewport.addEventListener('pointercancel', function (e) {
      if (e.pointerId === pointerId) endDrag(false);
    }, { passive: true });

    play();
  }

  function init() {
    document.querySelectorAll('[data-holo-deck]').forEach(initDeck);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
